<template>
  <div :class="{'main-section': this.sectionType == 'intro'}" class="section-box__title">
  <div class="section-box__title--box">
    <div>
      <div class="title__box dot" v-bind:class="['dot__color--'+dot, 'title__box--txt-'+textColor]">
        <span class="text-wrap project-logo__wrap">
          <transition
            appear
            mode="out-in"
            @appear="enterText"
            @enter="enterText"
            @leave="leaveText"
          >
            <img v-if="projectLogo && showChild" :src="require(`@/assets/${projectLogo}`)" :class="name">
          </transition>
        </span>


        <h3 v-if="this.sectionType == 'intro'" class="text-wrap text-wrap__small">
          <transition
            appear
            mode="out-in"
            @appear="enterText"
            @enter="enterText"
            @leave="leaveText"
          >
            <span v-show="showChild" v-html="subtitle"></span>
          </transition>
        </h3>

        <h2 v-bind:class="{contact_title: this.sectionType == 'contact'}">
          <span v-for="(line, index) in title" :key="index" class="text-wrap">
            <transition
              mode="out-in"
              appear
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild" v-html="line"></span>
            </transition>
          </span>
        </h2>
        <div v-if="this.sectionType == 'intro'" v-html="scrollIcon" class="scroll-icon"></div>
      </div>

      <div
        v-if="this.sectionType == 'caseStudy'"
        class="specification"
        v-bind:class="this.specificationColor"
      >
        <ul>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">Agency</span>
            </transition>
          </li>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">{{this.agency}}</span>
            </transition>
          </li>
        </ul>
        <ul>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">Client</span>
            </transition>
          </li>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">{{this.client}}</span>
            </transition>
          </li>
        </ul>
        <ul>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">Role</span>
            </transition>
          </li>
          <li class="text-wrap text-wrap__small">
            <transition
              appear
              mode="out-in"
              @appear="enterText"
              @enter="enterText"
              @leave="leaveText"
            >
              <span v-show="showChild">{{this.role}}</span>
            </transition>
          </li>
        </ul>
      </div>

      <div
        v-if="this.sectionType == 'contact'"
        class="section__contact--submenu"
        v-bind:class="this.specificationColor"
      >
        <div class="section__contact--submenu--column">
          <ul>
            <li class="text-wrap text-wrap__small">
              <transition appear @appear="enterText" @enter="enterText" @leave="leaveText">
                <span v-show="showChild">
                  <div class="dot"></div>
                </span>
              </transition>
            </li>
            <li class="text-wrap text-wrap__small">
              <transition appear @appear="enterText" @enter="enterText" @leave="leaveText">
                <span v-show="showChild">Rzeszow / Poland</span>
              </transition>
            </li>

            <li class="text-wrap text-wrap__small">
              <transition appear @appear="enterText" @enter="enterText" @leave="leaveText">
                <span v-show="showChild">ul. Przemyslowa 14b</span>
              </transition>
            </li>
          </ul>
          <ul>
            <li class="text-wrap text-wrap__small">
              <transition appear @appear="enterText" @enter="enterText" @leave="leaveText">
                <span v-show="showChild">m: hello[at]intervi.co.</span>
              </transition>
            </li>
            <li class="text-wrap text-wrap__small">
              <transition appear @appear="enterText" @enter="enterText" @leave="leaveText">
                <span v-show="showChild">p: +48 510 069 993</span>
              </transition>
            </li>
          </ul>
        </div>
      </div>

      <div router-link tag="li" class="show-more" v-if="this.sectionType == 'caseStudy'">
        <transition appear mode="out-in" @appear="enterText" @enter="enterText" @leave="leaveText">
          <a v-show="showChild" v-bind:href="this.projectPage">Show me this project</a>
        </transition>
      </div>

      <div class="page-url" v-if="this.sectionType == 'caseStudy'">
        <transition appear mode="out-in" @appear="enterText" @enter="enterText" @leave="leaveText">
          <a v-show="showChild" v-bind:href="this.url" target="_blank">{{this.changeUrl(this.url)}}</a>
        </transition>
      </div>
    </div>
  </div>
   </div>

</template>

<script>
export default {
  name: "SectionTitle",
  data() {
    return {
    };
  },
  methods: {
    // get url to external link project and change http to www
    changeUrl: link => {
      if ( link != undefined) {
      var link;
      const linkHttp = link.slice(7);
      var linkWWW = 'www.' + linkHttp
      return linkWWW;
      }

    },
    enterText: function(el, done) {
      TweenMax.fromTo( el, .9,
        { y: "155%" },
        {
          ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
          // delay: .5,
          y: "0%",
          onComplete: done
        }
      );
    },
    leaveText: function(el, done) {
      TweenMax.to(el, .9, {
        y: "-155%",
        ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
        delay: .1,
        onComplete: done
      });
    }
  },
  props: [
    "title",
    "name",
    "dot",
    "textColor",
    "specificationColor",
    "agency",
    "client",
    "role",
    "url",
    "showChild",
    "sectionType",
    "subtitle",
    "projectPage",
    "projectLogo",
    "scrollIcon"
  ]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/SectionTitle.vue